/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Table,
  TextInput,
  LoadingIndicator,
  FModal,
  Icons,
  WideAlert,
} from '@components';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { currency } from '@utils';
import { toast } from 'react-toastify';
import { PercentualRecebimentoRendaService } from '@services';
import { Formik, Field } from 'formik';
import { object, number } from 'yup';
import { mdiAlertCircleOutline, mdiCheckCircleOutline } from '@mdi/js';

const service = new PercentualRecebimentoRendaService();

export const PercentualRecebimentoRendaMensalPage = () => {
  const { matricula, plano } = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [msgRetTrocaPercentual, setMsgRetTrocaPercentual] = useState('');
  const [statusRetTrocaPercentual, setStatusRetTrocaPercentual] = useState('');
  const [percRecebimentoActual, setPercRecebimentoActual] = useState(0);
  const [percRecebimentoForm, setPercRecebimentoForm] = useState(0);
  const [saldoContasRemanescente, setSaldoContasRemanescente] = useState(0);
  const [novoValorBeneficio, setNovoValorBeneficio] = useState(0);
  const [beneficioAtual, setBeneficioAtual] = useState(0);
  const [limitePercentual, setLimitePercentual] = useState(1);

  const recuperaValores = useCallback(async () => {
    const valorRecebimentoSaldoContas = await service.getRecebimentoSaldoContas(
      matricula,
      plano
    );

    const valorSaldoContasRemanescente =
      await service.getSaldoRemanescenteParticipante(matricula);

    const valorBeneficioAtual = await service.getValorBeneficioParticipante(
      matricula,
      plano
    );

    setPercRecebimentoActual(valorRecebimentoSaldoContas.replace(',', '.'));
    setBeneficioAtual(valorBeneficioAtual.replace(',', '.'));
    setSaldoContasRemanescente(valorSaldoContasRemanescente.replace(',', '.'));
    setLoading(false);
  }, [matricula, plano]);

  useEffect(() => {
    recuperaValores();
  }, [recuperaValores]);

  const alterarValorBeneficio = async () => {
    setLoading(true);
    const percentualRecebimentoService =
      new PercentualRecebimentoRendaService();

    const valorRecebimentoSaldoContas =
      await percentualRecebimentoService.getRecebimentoSaldoContas(
        matricula,
        plano
      );

    const result =
      await percentualRecebimentoService.setTrocaPercentualRecebimentoRendaParticipanteSaldoConta(
        matricula,
        Number(valorRecebimentoSaldoContas.replace(',', '.')),
        parseFloat(percRecebimentoForm),
        parseFloat(saldoContasRemanescente)
      );

    setStatusRetTrocaPercentual(result.Alterado);
    setMsgRetTrocaPercentual(result.Value);
    setLoading(false);
    setModalIsOpen(true);
  };

  const simulacaoSchema = object({
    percRecebimento: number()
      .float(2, 'Máximo de duas casas decimais')
      .min(0.1, 'Valor mínimo permitido: 0.1')
      .max(limitePercentual, `Valor máximo permitido: ${limitePercentual}`)
      .typeError('Favor trocar vírgula (,) por ponto (.)')
      .required(`Insira um valor entre 0.1 e  ${limitePercentual}`),
  });

  useEffect(() => {
    service
      .getLimitePercentualCotasMensal(matricula, plano)
      .then((res) => {
        setLimitePercentual(res);
      })
      .catch(() => {
        toast.error('Erro ao obter dados');
      });
  }, [matricula, plano]);

  return (
    <>
      <Helmet>
        <title>Forluz - Percentual Recebimento Renda Mensal</title>
      </Helmet>

      {!loading ? (
        <div className="card">
          <div className="card-body">
            <span className="fw-bold ts-10 mb-32 mb-md-5">
              Alterar Percentual de Recebimento de Renda Mensal
            </span>
            <div className="row col-12 col-md-8 col-lg-8 mt-4">
              <h3 className="ts-20 fw-bold text-muted">Situação atual</h3>
              <Table
                className=" mt-2 mb-32"
                columns={[
                  '% Recebimento Saldo de Contas Atual',
                  'Saldo de Contas Remanescente',
                  'Pagamento Mês Anterior',
                ]}
              >
                <tr>
                  <td>{`${percRecebimentoActual} %`}</td>
                  <td>{currency(saldoContasRemanescente)}</td>
                  <td>{currency(beneficioAtual)}</td>
                </tr>
              </Table>
              <h3 className="ts-20 fw-bold text-muted">
                Recebimento saldo de contas desejado
              </h3>
              <Table
                className="mt-2 mb-32"
                columns={[
                  '% Recebimento Saldo de Contas Desejado',
                  'Novo Valor do benefício',
                ]}
              >
                <tr>
                  <td>
                    <Formik
                      enableReinitialize
                      initialValues={{ percRecebimento: '' }}
                      validationSchema={simulacaoSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        setNovoValorBeneficio(
                          (values.percRecebimento * saldoContasRemanescente) /
                            100
                        );
                        setPercRecebimentoForm(values.percRecebimento);
                        setSubmitting(false);
                      }}
                    >
                      {({ handleSubmit, isSubmitting, isValid }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="row ">
                            <div className="col-12 col-lg-7">
                              <Field
                                id="percRecebimento"
                                name="percRecebimento"
                                label="Percentual de recebimento"
                                tooltip={`Serão permitidos valores no intervalo entre 0.1 e ${limitePercentual}`}
                                component={TextInput}
                              />
                            </div>
                            <div className="col-12 col-lg-5  d-flex align-items-center justify-content-center">
                              <Button
                                transparent
                                color="orange"
                                type="submit"
                                disabled={isSubmitting || !isValid}
                              >
                                Recalcular
                              </Button>
                            </div>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </td>
                  <td className="ts-20 text-orange fw-bold">
                    {currency(novoValorBeneficio)}
                  </td>
                </tr>
              </Table>
              {!!percRecebimentoForm &&
                percRecebimentoForm < percRecebimentoActual && (
                  <WideAlert className="mb-4" iconClear={false}>
                    <div className="d-block d-lg-flex align-items-center">
                      <p className="ts-16">
                        <strong>Aviso importante:</strong> Não deixe de
                        verificar se o novo valor de benefício simulado é
                        suficiente para comportar os descontos em folha.
                        Lembramos que existe uma carência de 06 meses para
                        aumentar o percentual de retirada mensal.
                      </p>
                    </div>
                  </WideAlert>
                )}
              <div className="col-12 col-lg-6 mb-32">
                <Button
                  className="mt-32"
                  disabled={novoValorBeneficio === 0}
                  onClick={alterarValorBeneficio}
                >
                  Alterar valor do benefício
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingIndicator />
      )}
      <FModal isOpen={modalIsOpen} close onClose={() => setModalIsOpen(false)}>
        {statusRetTrocaPercentual ? (
          <>
            <Icons
              path={mdiCheckCircleOutline}
              color="var(--success)"
              size={2}
            />
            <h1 className="ts-20 fw-bold mb-1">Dados atualizados</h1>
            <p className="ts-16">{msgRetTrocaPercentual}</p>
          </>
        ) : (
          <>
            <Icons path={mdiAlertCircleOutline} color="var(--error)" size={2} />
            <h1 className="ts-20 fw-bold mb-1">Ocorreu um erro</h1>
            <p className="ts-16">{msgRetTrocaPercentual}</p>
          </>
        )}
      </FModal>
    </>
  );
};
